import { createSlice,PayloadAction} from '@reduxjs/toolkit';
import BigNumber from "bignumber.js";

import { AccountDetails,BalanceMap, NativeBalance,Issuer,AssetToken,NativeToken,AssetBalance} from "../../../stellar/wallet-sdk/types"

const initialIssuer:Issuer = {
  key:"any"
}

const initialAssetToken: AssetToken = {
  type :"credit_alphanum4",
  code:"any",
  issuer:initialIssuer,
}

const nativeToken: NativeToken = {
  type :"native",
  code:"XLM", 
}

const initialassetBalance: AssetBalance ={
  available: new BigNumber(0),
  total:new BigNumber(0),
  buyingLiabilities: new BigNumber(0),
  sellingLiabilities: new BigNumber(0),
  token: initialAssetToken
}

const initialNativeBalance: NativeBalance = {
  token: nativeToken,
  total:new BigNumber(0),
  available: new BigNumber(0),
  buyingLiabilities: new BigNumber(0),
  sellingLiabilities: new BigNumber(0),
  minimumBalance:new BigNumber(0) 
}

const initialBalanceState:BalanceMap = {

  "any:any":initialassetBalance,
  native: initialNativeBalance
}

let initialAccountDetails:AccountDetails = {
  id: '',
  subentryCount: 0,
  sponsoringCount: 0,
  sponsoredCount: 0,
  sponsor: '',
  inflationDestination: '',
  thresholds:{
    "low_threshold": 0,
    "med_threshold": 0,
    "high_threshold": 0,
  },
  signers: [],
  flags:{
    "auth_required": false,
    "auth_revocable": false,
    "auth_immutable": false,
    "auth_clawback_enabled": false

  } ,
  balances: initialBalanceState,
  sequenceNumber:''
};


const initialState = initialAccountDetails
   
const accountDetailsSlice = createSlice({
  name: 'account-info',
  initialState,
  reducers: {

    setAccountInfo: (state,action:PayloadAction<AccountDetails>) => {

      return (state = action.payload)
      
    },

  }
  
});

// Reducer
export default accountDetailsSlice.reducer;

// Actions
export const {setAccountInfo} = accountDetailsSlice.actions;


